export const API_EDIT = '/p/wedding/index.php/Admin/APIMerchant/edit'
export const API_MAIN_EDIT = '/p/wedding/index.php/mainAdmin/APIMerchant/edit'
export const API_SHOP_INFO = '/p/wedding/index.php/Admin/APIMerchant/shopInfo'
